import Navbar from "./Navbar/Navbar"
import Products from "./Products"

export default function Dashboard() {
    return (
        <>
            <Navbar />
            <>
            <Products />
            </>
        </>
    )
}